import React, { useState } from "react";
import Layout from "../Componants/Layout";
import { Accordion, Col, Container, Modal, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import moment from "moment/moment";
import { filterTheArray, getQueryParams, truncateText } from "../utils/HelperFunctions";
import MembersModal from "../Modal/MembersModal";
import useModifyVendorStatus from "../hooks/useModifyVendorStatus";
import DisplayStar from "../Componants/DisplayStar";
import UserLocationMap from "../Componants/UserLocationMap";
import toast from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import { isMobile, isTablet } from "react-device-detect";

export default function ElectricianProfile() {
  const Location = useLocation();
  const queryParams = getQueryParams(Location?.search);
  const { leadId, vendorId } = queryParams;

  const { changeVendorLikeStatus } = useModifyVendorStatus();
  console.log("LocationLocationLocationLocation", Location);
  const Navigate = useNavigate();
  const [memberDetail, setMemberDetail] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showSecond, setShowSecond] = useState(false);

  const [showAll, setShowAll] = useState(false);
  const [showService, setShowService] = useState(false);

  // Handle the "See More" button click
  const handleSeeMore = () => {
    setShowAll(!showAll);
  };

  const handleSeeMoreServices = () => {
    setShowService(!showService);
  };
  const handleSecondClose = () => {
    setMemberDetail({});
    setShowSecond(false);
  };
  const handleSecondShow = (member) => {
    setMemberDetail(member);
    setShowSecond(true);
  };

  const [activeKey, setActiveKey] = useState(null);

  const {
    data: electricianProfile,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["electricianProfile"],
    queryFn: () => {
      const url = `/profile/view/vendor${Location.search}`;
      return getRequest(url); // Ensure the result of getRequest is returned
    },
    enabled: !!Location?.search, // Ensure the query only runs if Location.search exists
  });

  const handleAccordionToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const handleLikeDislike = (path, status) => {
    const queryParams = getQueryParams(path);
    const { leadId, vendorId } = queryParams;
    changeVendorLikeStatus({ id: vendorId, status });
  };

  const { mutate: requestContact, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest("/profile/contact", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode == 200) {
        toast.success(`Request sent successfully`, {
          iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
          },
        })
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleContact = () => {
    const payload = {
      vendorId: vendorId
    }
    requestContact(payload)
  }



  console.log(isLoading, "isLoadingisLoadingisLoadingisLoading567")

  const rating = electricianProfile?.data?.rating
    ? Math.floor(electricianProfile.data.rating)
    : 0;
  return (
    <>
      <div className="nav-back-sec">
        <Container>
          <div className="">
            <button onClick={() => Navigate(-1)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" />
              </svg>
              Back
            </button>
          </div>
        </Container>
      </div>

      <Container>
        {isLoading ?
          <div style={{ marginTop: "-70px" }} >

            <div>
              <div className="view-profile-img-icon">
                <div className="businesses-img verifide-badge">
                  <Skeleton circle={true} height={140} width={140} />
                </div>
                <div className="view-profile-icons">

                </div>
              </div>

              <div className="mt-2">
                <h3><Skeleton width={150} /></h3>
                <p ><Skeleton width={200} /></p>
                <div className="start-rate">
                  <Skeleton width={120} height={35} />
                </div>
              </div>


              <div className="mt-5">
                <h3><Skeleton width={150} /></h3>
                <p className="mb-2"><Skeleton width={200} /></p>
                <div className="start-rate mt-3">
                  <Skeleton width={120} height={35} />
                </div>
              </div>
            </div>

            <Skeleton count={5} height={40} />

          </div> :
          <>
            <div className={isMobile || isTablet ? " no-flex profile electrician-profile-data" : "electrician-profile-data"} >
              <div className="data-left">
                <div>
                  <div className="view-profile-img-icon">
                    <div className="businesses-img verifide-badge">
                      {electricianProfile?.data?.image ? (
                        <img
                          src={electricianProfile?.data?.image}
                          className={
                            electricianProfile?.data?.subscription?.plan ==
                              "Premium"
                              ? "prime-profile"
                              : ""
                          }
                        />
                      ) : (
                        <div
                          className={
                            electricianProfile?.data?.subscription?.plan ==
                              "Premium"
                              ? "electricianProfile-custom-circle prime-profile"
                              : "electricianProfile-custom-circle "
                          }
                        >
                          <span className="">
                            {electricianProfile?.data?.bussinessName
                              ? electricianProfile?.data?.bussinessName
                                .toUpperCase()
                                .at(0)
                              : "N"}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="view-profile-icons">
                      {electricianProfile?.data?.verificationStatus ==
                        "Approved" && (
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="35"
                              height="35"
                              viewBox="0 0 27 27"
                              fill="none"
                            >
                              <rect
                                width="25"
                                height="25"
                                rx="12.5"
                                transform="matrix(-1 0 0 1 26 1)"
                                fill="#337FE0"
                                stroke="white"
                                stroke-width="2"
                              />
                              <path
                                d="M20.0001 10L11.7066 16.8581L8 13.2486"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        )}

                      {electricianProfile?.data?.subscription?.plan ==
                        "Premium" && (
                          <span className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="35"
                              height="35"
                              viewBox="0 0 27 27"
                              fill="none"
                            >
                              <rect
                                width="25"
                                height="25"
                                rx="12.5"
                                transform="matrix(-1 0 0 1 26 1)"
                                fill="#FFC130"
                                stroke="white"
                                stroke-width="2"
                              />
                              <path
                                d="M19.9998 12.42L18.7698 17.855C18.7454 17.9687 18.6821 18.0704 18.5908 18.1425C18.4996 18.2146 18.386 18.2526 18.2698 18.25H8.68976C8.57349 18.2526 8.45995 18.2146 8.36869 18.1425C8.27743 18.0704 8.21416 17.9687 8.18976 17.855L6.99976 12.42C6.97974 12.3282 6.986 12.2325 7.01784 12.1441C7.04968 12.0557 7.1058 11.978 7.17976 11.92C7.25393 11.8618 7.34305 11.8257 7.43683 11.816C7.5306 11.8063 7.62522 11.8233 7.70976 11.865L10.6298 13.28L13.0498 9C13.0934 8.92305 13.1566 8.85904 13.233 8.81451C13.3095 8.76998 13.3963 8.74652 13.4848 8.74652C13.5732 8.74652 13.6601 8.76998 13.7365 8.81451C13.8129 8.85904 13.8762 8.92305 13.9198 9L16.3398 13.285L19.2798 11.86C19.3649 11.8149 19.4613 11.7953 19.5573 11.8036C19.6533 11.812 19.7448 11.8479 19.8209 11.9071C19.897 11.9663 19.9543 12.0461 19.9861 12.1371C20.0178 12.2281 20.0225 12.3264 19.9998 12.42Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        )}
                    </div>
                  </div>

                  <div>
                    <h3>{electricianProfile?.data?.bussinessName}</h3>
                    <p className="mb-2">
                      {electricianProfile?.data?.city ||
                        `${filterTheArray(
                          electricianProfile?.data?.address
                        )}, ${electricianProfile?.data?.postCode?.slice(0, 3)}`}
                    </p>
                    <div className="start-rate">
                      <DisplayStar
                        rating={Math.floor(electricianProfile?.data?.rating)}
                        size={22}
                      />

                      {electricianProfile?.data?.review == 0 ?
                        <span>(0 reviews)</span> :
                        <span>({`${electricianProfile.data.review} ${electricianProfile.data.review == 1 ? 'review' : 'reviews'}`})</span>
                      }

                    </div>
                  </div>
                </div>
                <button className="theme-comm-btn w-100" onClick={handleShow}>
                  Contact
                </button>
              </div>
              <div className="data-right">
                <div>
                  {electricianProfile?.data?.isfavourite ? (
                    <p
                      onClick={() => handleLikeDislike(Location.search, false)}
                      className="active"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect width="24" height="24" fill="white" />
                        <path
                          d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z"
                          fill="#337FE0"
                          stroke="#337FE0"
                          strokeWidth="2"
                        />
                      </svg>
                    </p>
                  ) : (
                    <p onClick={() => handleLikeDislike(Location.search, true)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect width="24" height="24" fill="white" />
                        <path
                          d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z"
                          fill=""
                          stroke="#337FE0"
                          strokeWidth="2"
                        />
                      </svg>
                    </p>
                  )}
                </div>
                {Array.isArray(electricianProfile?.data?.employees) &&
                  electricianProfile?.data?.employees.length > 0 ? (
                  <div>
                    <p
                      className="cursor-pointer"
                      onClick={() =>
                        Navigate(`/all-team-members${Location?.search}`)
                      }
                    >
                      See All Team Members
                    </p>
                    <ul>
                      {electricianProfile?.data?.employees.map((ele, index) => {
                        return (
                          <li key={index}>
                            <div
                              className="businesses-img  cursor-pointer"
                              onClick={() => handleSecondShow(ele)}
                            >
                              <img
                                src={
                                  ele?.image
                                    ? ele?.image
                                    : require("../assets/images/vector-logo.svg").default
                                }
                              />
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="about-us-data">
              <div className="electrician-comn-title">
                <h3>About Us</h3>
              </div>
              <div />
              <div className="elect-descri">
                {electricianProfile?.data?.description && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: electricianProfile?.data?.description,
                    }}
                  ></p>
                )}
              </div>
              <div className="electrician-info">
                {electricianProfile?.data?.companySize && (
                  <div>
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M17.233 15.328C17.0667 14.1985 16.5012 13.166 15.6389 12.4178C14.7766 11.6696 13.6746 11.2553 12.533 11.25H11.469C10.3273 11.2553 9.2254 11.6696 8.36308 12.4178C7.50077 13.166 6.9352 14.1985 6.76897 15.328L6.25897 18.894C6.24268 19.0093 6.25345 19.1267 6.29042 19.2371C6.32739 19.3475 6.38955 19.4478 6.47197 19.53C6.67197 19.73 7.89897 20.75 12.002 20.75C16.105 20.75 17.329 19.734 17.532 19.53C17.6144 19.4478 17.6766 19.3475 17.7135 19.2371C17.7505 19.1267 17.7613 19.0093 17.745 18.894L17.233 15.328ZM7.55997 11.8C6.59351 12.691 5.96467 13.8886 5.77997 15.19L5.40997 17.75C2.43997 17.73 1.53997 16.65 1.38997 16.43C1.33199 16.3501 1.29062 16.2593 1.26829 16.1632C1.24596 16.067 1.24313 15.9673 1.25997 15.87L1.47997 14.63C1.5946 13.982 1.8638 13.3711 2.26475 12.8492C2.6657 12.3274 3.18658 11.9099 3.78322 11.6322C4.37987 11.3544 5.03468 11.2247 5.69214 11.2539C6.3496 11.2831 6.99032 11.4705 7.55997 11.8ZM22.74 15.87C22.7568 15.9673 22.754 16.067 22.7317 16.1632C22.7093 16.2593 22.668 16.3501 22.61 16.43C22.46 16.65 21.56 17.73 18.59 17.75L18.22 15.19C18.0353 13.8886 17.4064 12.691 16.44 11.8C17.0096 11.4705 17.6504 11.2831 18.3078 11.2539C18.9653 11.2247 19.6201 11.3544 20.2167 11.6322C20.8134 11.9099 21.3343 12.3274 21.7352 12.8492C22.1362 13.3711 22.4054 13.982 22.52 14.63L22.74 15.87ZM7.72997 9.6C7.47825 9.957 7.14408 10.248 6.75585 10.4482C6.36761 10.6484 5.93679 10.7519 5.49997 10.75C5.06423 10.75 4.63473 10.6465 4.24685 10.4479C3.85898 10.2493 3.52384 9.96145 3.26906 9.60795C3.01428 9.25446 2.84714 8.84548 2.78143 8.41472C2.71571 7.98397 2.7533 7.54376 2.8911 7.13037C3.02889 6.71699 3.26294 6.34227 3.57397 6.03709C3.885 5.73191 4.26409 5.50501 4.68001 5.37509C5.09594 5.24516 5.53678 5.21594 5.96621 5.28981C6.39565 5.36369 6.80138 5.53856 7.14997 5.8C7.04971 6.1921 6.99931 6.59529 6.99997 7C7.00074 7.91715 7.25325 8.81649 7.72997 9.6ZM21.25 8C21.2502 8.36121 21.1793 8.71893 21.0412 9.05269C20.9031 9.38646 20.7005 9.68972 20.4451 9.94513C20.1897 10.2005 19.8864 10.4031 19.5527 10.5412C19.2189 10.6793 18.8612 10.7503 18.5 10.75C18.0632 10.7519 17.6323 10.6484 17.2441 10.4482C16.8559 10.248 16.5217 9.957 16.27 9.6C16.7467 8.81649 16.9992 7.91715 17 7C17.0006 6.59529 16.9502 6.1921 16.85 5.8C17.2585 5.49358 17.7444 5.30698 18.253 5.26111C18.7617 5.21525 19.273 5.31193 19.7298 5.54033C20.1866 5.76872 20.5708 6.11981 20.8393 6.55424C21.1078 6.98867 21.25 7.48929 21.25 8Z"
                          fill="black"
                        />
                        <path
                          d="M12 10.75C14.0711 10.75 15.75 9.07107 15.75 7C15.75 4.92893 14.0711 3.25 12 3.25C9.92893 3.25 8.25 4.92893 8.25 7C8.25 9.07107 9.92893 10.75 12 10.75Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    {electricianProfile?.data?.companySize == "soleTrader"
                      ? "Solo Trader"
                      : electricianProfile?.data?.companySize}{" "}
                  </div>
                )}

                {electricianProfile?.data?.verificationStatus ==
                  "Approved" && (
                    <div>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="35"
                          viewBox="0 0 27 27"
                          fill="none"
                        >
                          <rect
                            width="25"
                            height="25"
                            rx="12.5"
                            transform="matrix(-1 0 0 1 26 1)"
                            fill="#337FE0"
                            stroke="white"
                            stroke-width="2"
                          />
                          <path
                            d="M20.0001 10L11.7066 16.8581L8 13.2486"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Verified Member
                    </div>

                  )}


                <div>
                  <span>

                    {electricianProfile?.data?.subscription?.plan ==
                      "Premium" ?

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          d="M1.38889 11.9998C1.38889 5.86329 6.3635 0.888672 12.5 0.888672C18.6365 0.888672 23.6111 5.86329 23.6111 11.9998C23.6111 18.1363 18.6365 23.1109 12.5 23.1109C6.3635 23.1109 1.38889 18.1363 1.38889 11.9998Z"
                          fill="#FFC130"
                        />
                        <path
                          d="M18.2776 11.0397L17.1843 15.8708C17.1626 15.9719 17.1063 16.0623 17.0252 16.1264C16.9441 16.1905 16.8431 16.2243 16.7398 16.222H8.22425C8.1209 16.2243 8.01997 16.1905 7.93885 16.1264C7.85773 16.0623 7.80149 15.9719 7.7798 15.8708L6.72202 11.0397C6.70423 10.9581 6.70979 10.8731 6.7381 10.7945C6.7664 10.7159 6.81628 10.6468 6.88202 10.5953C6.94795 10.5436 7.02717 10.5115 7.11053 10.5028C7.19388 10.4942 7.27799 10.5093 7.35314 10.5464L9.94873 11.8042L12.0998 7.99973C12.1386 7.93133 12.1948 7.87443 12.2627 7.83485C12.3307 7.79527 12.4078 7.77441 12.4865 7.77441C12.5651 7.77441 12.6423 7.79527 12.7102 7.83485C12.7781 7.87443 12.8344 7.93133 12.8732 7.99973L15.0243 11.8086L17.6376 10.542C17.7133 10.5019 17.7989 10.4844 17.8843 10.4918C17.9696 10.4993 18.0509 10.5312 18.1186 10.5838C18.1862 10.6364 18.2372 10.7074 18.2654 10.7883C18.2936 10.8692 18.2978 10.9565 18.2776 11.0397Z"
                          fill="white"
                        />
                      </svg> :



                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 16 16" fill="none">
                        <path d="M8 9C9.38071 9 10.5 7.88071 10.5 6.5C10.5 5.11929 9.38071 4 8 4C6.61929 4 5.5 5.11929 5.5 6.5C5.5 7.88071 6.61929 9 8 9Z" fill="#000000" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6 10C4.80291 10 3.76957 10.7012 3.28827 11.7152C2.48151 10.6934 2 9.40294 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.40294 13.5185 10.6934 12.7117 11.7152C12.2304 10.7012 11.1971 10 10 10H6Z" fill="#000000" />
                      </svg>

                    }
                  </span>
                  {electricianProfile?.data?.subscription?.plan} Member
                </div>

                {electricianProfile?.data?.incorporationDate && (
                  <div>
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M17 4.75C16.59 4.75 16.25 4.41 16.25 4V2C16.25 1.59 16.59 1.25 17 1.25C17.41 1.25 17.75 1.59 17.75 2V4C17.75 4.41 17.41 4.75 17 4.75ZM7 4.75C6.59 4.75 6.25 4.41 6.25 4V2C6.25 1.59 6.59 1.25 7 1.25C7.41 1.25 7.75 1.59 7.75 2V4C7.75 4.41 7.41 4.75 7 4.75Z"
                          fill="black"
                        />
                        <path
                          d="M22.75 8.25V7C22.75 4.93 21.07 3.25 19 3.25H5C2.93 3.25 1.25 4.93 1.25 7V8.25H22.75ZM1.25 9.75V19C1.25 21.07 2.93 22.75 5 22.75H19C21.07 22.75 22.75 21.07 22.75 19V9.75H1.25ZM7 19C6.45 19 6 18.55 6 18C6 17.45 6.45 17 7 17C7.55 17 8 17.45 8 18C8 18.55 7.55 19 7 19ZM7 14C6.45 14 6 13.55 6 13C6 12.45 6.45 12 7 12C7.55 12 8 12.45 8 13C8 13.55 7.55 14 7 14ZM12 19C11.45 19 11 18.55 11 18C11 17.45 11.45 17 12 17C12.55 17 13 17.45 13 18C13 18.55 12.55 19 12 19ZM12 14C11.45 14 11 13.55 11 13C11 12.45 11.45 12 12 12C12.55 12 13 12.45 13 13C13 13.55 12.55 14 12 14ZM17 19C16.45 19 16 18.55 16 18C16 17.45 16.45 17 17 17C17.55 17 18 17.45 18 18C18 18.55 17.55 19 17 19ZM17 14C16.45 14 16 13.55 16 13C16 12.45 16.45 12 17 12C17.55 12 18 12.45 18 13C18 13.55 17.55 14 17 14Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    Incorporated{" "}
                    {electricianProfile?.data?.incorporationDate
                      ? moment(
                        electricianProfile?.data?.incorporationDate
                      ).format("MMMM YYYY")
                      : "N/A"}{" "}
                  </div>
                )}
                {/* {electricianProfile?.data?.createdAt && (
                <div>
                  Member Since{" "}
                  {electricianProfile?.data?.createdAt
                    ? moment(electricianProfile?.data?.createdAt).format(
                        "MMMM YYYY"
                      )
                    : "N/A"}
                </div>
              )} */}
              </div>
            </div>
            <div className="about-us-data">
              <div className="electrician-comn-title">
                <h3>Services</h3>
              </div>
              <div className="faq-list-accro">
                <Accordion
                  activeKey={activeKey}
                  onSelect={handleAccordionToggle}
                  flush
                >
                  {Array.isArray(electricianProfile?.data?.vendorServices) && electricianProfile?.data?.vendorServices
                    ?.slice(
                      0,
                      showService ? electricianProfile?.data?.vendorServices.length : 3
                    ).map((ele, index) => {
                      return (
                        <Accordion.Item key={index} eventKey={index.toString()}>
                          <Accordion.Header>
                            {ele?.category?.categoryName}
                          </Accordion.Header>
                          <Accordion.Body>
                            <ul className="services-check-list">
                              {Array.isArray(ele?.services) &&
                                ele?.services.map((val, index) => {
                                  return (
                                    <li key={index}>
                                      <p>{val?.serviceName}</p>
                                    </li>
                                  );
                                })}
                            </ul>
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                </Accordion>
              </div>

              <>
                {Array.isArray(electricianProfile?.data?.vendorServices) && electricianProfile?.data?.vendorServices.length > 3 && (
                  <Col lg={12}>
                    <div className="d-flex justify-content-center mt-4">
                      <button
                        className="theme-white-comm-btn"
                        onClick={handleSeeMoreServices}
                      >
                        {" "}
                        {showService ? "See Less" : "See More"}
                      </button>
                    </div>
                  </Col>
                )}
              </>


            </div>
            {Array.isArray(electricianProfile?.data?.portfolios) &&
              electricianProfile?.data?.portfolios.length > 0 ? (
              <div className="about-us-data">
                <div className="electrician-comn-title">
                  <h3>Portfolio</h3>
                </div>
                <Row>
                  {electricianProfile?.data?.portfolios
                    ?.slice(
                      0,
                      showAll ? electricianProfile?.data?.portfolios.length : 3
                    )
                    .map((ele, index) => {
                      return (
                        <Col lg={4} key={index}>
                          <div
                            className="popular-services-card cursor-pointer"
                            onClick={() =>
                              Navigate(
                                `/profile-portfolio-detail?portfolioId=${ele?._id}`
                              )
                            }
                          >
                            {ele?.image?.length > 0 ? (
                              <img
                                src={
                                  `${ele?.image[0]}` ||
                                  require("../assets/images/dimmy-img.png")
                                }
                              />
                            ) : (
                              <img
                                src={require("../assets/images/dimmy-img.png")}
                              />
                            )}
                            <h3>{ele?.projectName || "N/A"} </h3>
                            <p>
                              {ele?.description
                                ? truncateText(ele.description, 15)
                                : "N/A"}
                            </p>
                          </div>
                        </Col>
                      );
                    })}
                  <>
                    {electricianProfile?.data?.portfolios.length > 3 && (
                      <Col lg={12}>
                        <div className="d-flex justify-content-center mt-4">
                          <button
                            className="theme-white-comm-btn"
                            onClick={handleSeeMore}
                          >
                            {" "}
                            {showAll ? "See Less" : "See More"}
                          </button>
                        </div>
                      </Col>
                    )}
                  </>
                </Row>
              </div>
            ) : (
              <></>
            )}

            <div className="availability-data-set">
              <div className="avalibility-time">
                <div className="electrician-comn-title">
                  <h3>Business Hours</h3>
                </div>
                <ul>
                  {Array.isArray(electricianProfile?.data?.openingHours) &&
                    electricianProfile?.data?.openingHours.length > 0 &&
                    electricianProfile?.data?.openingHours.map((day, index) => (
                      <li key={index}>
                        <p>
                          {
                            [
                              "Monday",
                              "Tuesday",
                              "Wednesday",
                              "Thursday",
                              "Friday",
                              "Saturday",
                              "Sunday",
                            ][index]
                          }
                        </p>
                        {day.is24HourAvailable ? (
                          <span> (24/7)</span>
                        ) : day.from === "" && day.to === "" ? (
                          <span> (Closed)</span>
                        ) : (
                          <p>
                            {day.from} - {day.to}
                          </p>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
              {electricianProfile?.data?.location?.coordinates && (
                <div className="avalibility-map w-100">
                  {/* <img src={require("../assets/images/comn-map.png")} /> */}
                  <UserLocationMap
                    data={electricianProfile?.data?.location?.coordinates}
                    className="w-100"
                  />
                </div>
              )}
            </div>
            <div className="write-a-review">
              <div className="review-stars cursor-pointer" onClick={() => Navigate(`/electrician-reviews${Location?.search}`)} >
                <h2>
                  {electricianProfile?.data?.rating
                    ? parseFloat(electricianProfile.data.rating).toFixed(1)
                    : 0.0}
                </h2>
                <div className="start-rate">
                  <DisplayStar
                    rating={Math.floor(electricianProfile?.data?.rating)}
                    size={22}
                  />
                </div>
                {/* <p>({electricianProfile?.data?.review} reviews)</p> */}


                {electricianProfile?.data?.review == 0 ?
                  <span>(0 reviews)</span> :
                  <span>({`${electricianProfile.data.review} ${electricianProfile.data.review == 1 ? 'review' : 'reviews'}`})</span>
                }

              </div>
              <div className="review-progress">
                {/* <ul>
                {Object.entries(electricianProfile?.data?.ratingPercentage || {}).map(([key, value]) => (
                  <li key={key}>
                    <p>{key}</p>
                    <ProgressBar now={value} />
                  </li>
                ))}
              </ul> */}
                <ul>
                  {[
                    ...Object.entries(
                      electricianProfile?.data?.ratingPercentage || {}
                    ),
                  ]
                    .reverse()
                    .map(([key, value]) => (
                      <li key={key} onClick={() => Navigate(`/electrician-reviews${Location?.search}`)} className="cursor-pointer">
                        <p>{key}</p>
                        <ProgressBar now={value} />
                      </li>
                    ))}
                </ul>
              </div>
              {/* <div>
                <button
                  className="theme-white-comm-btn"
                  onClick={() => Navigate(`/leave-review?vendorId=${vendorId}`)}
                >
                  Write a review
                </button>
              </div> */}
            </div>
          </>
        }
      </Container>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <div>
            <div className="electrician-profile-pop">
              <h2 className="justify-content-between">
                <strong> {electricianProfile?.data?.bussinessName} </strong>
              </h2>
              {/* {electricianProfile?.data?.subscription?.plan == "Premium" ?
                <>

                  <div className="hidden-data-details">
                    <p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M13.7071 11.7071L16.3552 14.3552C16.7113 14.7113 16.7113 15.2887 16.3552 15.6448C14.43 17.57 11.3821 17.7866 9.20399 16.153L7.62857 14.9714C5.88504 13.6638 4.33622 12.115 3.02857 10.3714L1.84701 8.79601C0.213407 6.61788 0.430014 3.56999 2.35523 1.64477C2.71133 1.28867 3.28867 1.28867 3.64477 1.64477L6.29289 4.29289C6.68342 4.68342 6.68342 5.31658 6.29289 5.70711L5.27175 6.72825C5.10946 6.89054 5.06923 7.13846 5.17187 7.34373C6.35853 9.71706 8.28294 11.6415 10.6563 12.8281C10.8615 12.9308 11.1095 12.8905 11.2717 12.7283L12.2929 11.7071C12.6834 11.3166 13.3166 11.3166 13.7071 11.7071Z"
                          stroke="black"
                        />
                      </svg>

                      <a
                        href={`tel:+${electricianProfile?.data?.countryCode}${electricianProfile?.data?.phoneNumber}`}
                        style={{
                          textDecoration: "none",
                          color: "black",
                        }}
                      >
                        +{electricianProfile?.data?.countryCode} {electricianProfile?.data?.phoneNumber}
                      </a>


                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                    >
                      <rect
                        width="15"
                        height="15"
                        rx="7.5"
                        transform="matrix(-1 0 0 1 16 1)"
                        stroke="#27CA40"
                      />
                      <path
                        d="M11.7812 6.75812L7.24578 10.6095L5.21875 8.58245"
                        stroke="#27CA40"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="hidden-data-details">
                    <p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="17"
                        viewBox="0 0 20 17"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.771209 2.8697C0.937745 2.784 1.13821 2.79856 1.29062 2.90742L9.12814 8.50565C9.64969 8.87818 10.3503 8.87818 10.8719 8.50565L18.7094 2.90742C18.8618 2.79856 19.0623 2.784 19.2288 2.8697C19.3953 2.95541 19.5 3.12699 19.5 3.31429V14.3C19.5 15.6807 18.3807 16.8 17 16.8H3C1.61929 16.8 0.5 15.6807 0.5 14.3V3.31429C0.5 3.12699 0.604674 2.95541 0.771209 2.8697ZM1.5 4.28588V14.3C1.5 15.1284 2.17157 15.8 3 15.8H17C17.8284 15.8 18.5 15.1284 18.5 14.3V4.28588L11.4531 9.31938C10.5839 9.94027 9.41615 9.94027 8.5469 9.31938L1.5 4.28588Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H17C18.3807 0.5 19.5 1.61929 19.5 3V3.57159L11.4531 9.31938C10.5839 9.94027 9.41615 9.94027 8.5469 9.31938L0.5 3.57159V3ZM3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V3.05698L9.12814 8.50565C9.64969 8.87818 10.3503 8.87818 10.8719 8.50565L18.5 3.05698V3C18.5 2.17157 17.8284 1.5 17 1.5H3Z"
                          fill="black"
                        />
                      </svg>

                      <a
                        href={`mailto:${electricianProfile?.data?.email}`}
                        style={{
                          textDecoration: "none",
                          color: "black",
                        }}
                      >
                        {electricianProfile?.data?.email}
                      </a>



                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                    >
                      <rect
                        width="15"
                        height="15"
                        rx="7.5"
                        transform="matrix(-1 0 0 1 16 1)"
                        stroke="#27CA40"
                      />
                      <path
                        d="M11.7812 6.75812L7.24578 10.6095L5.21875 8.58245"
                        stroke="#27CA40"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </> :
                <div className="w-70 mx-auto mt-4 ">
                  <button className="theme-comm-btn w-100 mb-2" onClick={() => handleContact()}>
                  Contact Me dad
                  </button>
                </div>
              } */}

              <div className="w-70 mx-auto mt-4 ">
                <button className="theme-comm-btn w-100 mb-2" onClick={() => handleContact()}>
                  Contact Me
                </button>
                {/* <button className="theme-comm-btn w-100" onClick={() => handleContact()}>Call Me</button> */}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <MembersModal
        showSecond={showSecond}
        handleSecondClose={handleSecondClose}
        memberDetail={memberDetail}
      />

    </>
  );
}
